
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {DateTime} from "luxon";

@Component
export default class DateInputMenu extends Vue {

  @Prop({required: false})
  value: Date;

  @Prop({required: false, default: () => ""})
  emptyText: string;

  @Prop({required: false, default: () => ""})
  label: string;

  @Prop({required: false, default: () => true})
  clearable: string;

  @Prop({required: false, default: () => ""})
  iconColor: string;

  @Prop({required: false, default: () => () => true})
  allowedDates: Function

  showMenu = false;
  internalDate = "";

  @Watch("value", {immediate: true})
  handleValueChange(newValue: Date) {
    if (!newValue) return "";

    this.internalDate = DateTime.fromJSDate(newValue).toFormat("yyyy-MM-dd");
  }

  @Watch("internalDate", {immediate: true})
  handleInternalDateChange(newValue: string) {
    const emitDate = newValue == ""
        ? null
        : DateTime.fromISO(newValue).toJSDate();

    this.$emit("input", emitDate);
  }

  formatDate(isoDate: string): string {
    return isoDate
        ? DateTime.fromISO(isoDate).toFormat("dd.MM.yyyy")
        : this.emptyText;
  }



}
